var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 44,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_148_1471",
    transform: "translate(0 -0.136364) scale(0.0104167 0.0118371)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_148_1471",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAACDklEQVR4nO3aMU4cQRCF4bcWgbOVz0JA6GPhkFshy0Ii4zYIZ3ZUBAzWgNFq2e2uVz39fzEenutnBYuQAAAAAAAAgE4i4joaSthbak8TLSMkbC21p5lWERJ2ltrTVIsICRtL7Wnu3AgJ+0rt6eKcCAnbSu3p5tQICbu67vnSY/SJ7iX9cY/IViJARFxKupX01b0lmz3Acvxfkr65tzhYA8x+fMkYgOO/sASIiCtJdzru+H87z7FKD7D6hrs/4sN/S/ou6UfXUbOIiMuIeDzyR+qn5ZXy+m8/fJ+QsLnr+4A05xx/9Yz/IiTsHj9Ai+OvnvUmQsL2sQO0PP7qmf8iJOwfN0CP46+efU2AAyLiajlq8+OvPsdNj+3vPsd4AaLjV3624QJs6fjSYAG2dnxpoABbPL40SICtHl8aIMCWjy8VD7D140uFA8xwfKlogFmOLxUMMNPxpZoBfs5yfKlmgH1EPMxwfKlggGXUoQjW47c+WMkAy7CPIti/8qcJsIxbR7Aff9k0T4Bl4D5evjHbjy+NF2B32n+zrs8eYbfbHbxB6+e9Z//b0NkRwIwAZgQwI4AZAcwIYEYAMwKYEcCMAGYX7gG9f9dSHa8AMwKYEcCMAGYEMCOAGQHMPv0+YPaf21vjFWBGADMCmBHAjABmBDAjgBkBzAhgRgAzApgRwIwAZgQwIwAAAAAAAACQ5Bl1bk+2shOTbgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.a52cdcb9d9be79db0f8207e639bbf475.svg";
export { ForwardRef as ReactComponent };